import { render, staticRenderFns } from "./BaseMitMyReservations.vue?vue&type=template&id=67420728&scoped=true"
import script from "./BaseMitMyReservations.vue?vue&type=script&lang=js"
export * from "./BaseMitMyReservations.vue?vue&type=script&lang=js"
import style0 from "./BaseMitMyReservations.vue?vue&type=style&index=0&id=67420728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67420728",
  null
  
)

export default component.exports